import { useEffect, useState, useContext } from "react"
import Header from "../../../layouts/Header"
import BackIcon from "../../../components/BackIcon"
import { useNavigate, useLocation } from "react-router-dom"
import { Box, Paper, TextField, Tooltip, IconButton, Grid, MenuItem, Typography } from "@mui/material"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { useMutation, api, showWarning } from "../../../api"
import { GlobalContext } from "../../../contexts/GlobalContext"
import getIconComponent from "../../utils/getIconComponent"

const theme = createTheme({
  palette: { primary: { main: "#196C87" }, secondary: { main: "#2E7D32" } },
})

const StyledRoot = {
  width: "100%",
  maxWidth: "800px",
  margin: "0 auto",
  padding: "20px",
  backgroundColor: "#f5f7fa",
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
}

const EditarTiposCliente = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const { selectedMenuInfo } = useContext(GlobalContext)

  const tipcodigoViejo = state?.tipcodigo ?? ""

  const [formData, setFormData] = useState({
    tipcodigo: "",
    tipdescri: "",
    tipstatus: "A",
  })

  useEffect(() => {
    if (state) {
      setFormData({
        tipcodigo: state.tipcodigo || "",
        tipdescri: state.tipdescri || "",
        tipstatus: state.tipstatus || "A",
      })
    }
  }, [state])

  const {
    mutateAsync: SaveEdicionTipoCliente,
    isPending: isSaving,
    isError,
  } = useMutation({
    queryKey: ["isEditingTipoCliente"],
    fn: async (data) => {
      const response = await api.post("/TiposCliente/updateTiposCliente", data)
      return response.data
    },
    showError: "modal",
    showSuccess: "toast",
    onSuccess: () => navigate(-1),
  })

  const handleInputChange = (field, value) => {
    let processedValue = value
    if (typeof value === "string") {
      processedValue = value.toUpperCase()
    }
    setFormData((prev) => ({ ...prev, [field]: processedValue }))
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault()

    const payload = {
      tipcodigoOld: tipcodigoViejo,
      tipcodigoNew: formData.tipcodigo,
      tipdescri: formData.tipdescri,
      tipstatus: formData.tipstatus,
      tipcobdir: 0, // Valor por defecto en actualización
      tipdefacr: 0, // Valor por defecto en actualización
    }

    try {
      if (!payload.tipcodigoNew.trim()) return showWarning("El Código del Tipo de Cliente es obligatorio")
      if (!payload.tipdescri.trim()) return showWarning("La descripción es obligatoria")

      await SaveEdicionTipoCliente(payload)
    } catch (error) {
      console.error("Error al editar el Tipo de Cliente:", error)
    }
  }

  const grabarAction = selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === "GRABAR")
  const toolbarActions = grabarAction
    ? [
        {
          label: grabarAction.acccaption,
          key: grabarAction.acccaption,
          icon: getIconComponent(grabarAction.accnameicono, grabarAction.acctipoico),
        },
      ]
    : []

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />

        <Box sx={{ mb: 2 }}>
          {toolbarActions.map((action) => (
            <Tooltip title={action.label} key={action.key}>
              <IconButton
                onClick={handleSubmit}
                disabled={isSaving}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, mr: 1 }}
              >
                {action.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Box>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Editar Tipo de Cliente</b>
        </div>

        <CustomBackdrop isLoading={isSaving} />

        <Box sx={StyledRoot}>
          <Paper
            elevation={3}
            sx={{ p: 4, borderRadius: 3, background: "white" }}
            component="form"
            onSubmit={handleSubmit}
          >
            <Typography variant="h6" color="primary" gutterBottom sx={{ mb: 3 }}>
              Información General
            </Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Código *"
                  value={formData.tipcodigo}
                  onChange={(e) => handleInputChange("tipcodigo", e.target.value)}
                  error={isError && !formData.tipcodigo}
                  inputProps={{ maxLength: 3 }}
                  InputLabelProps={{ shrink: true }}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={8}>
                <TextField
                  fullWidth
                  label="Descripción *"
                  value={formData.tipdescri}
                  onChange={(e) => handleInputChange("tipdescri", e.target.value)}
                  error={isError && !formData.tipdescri}
                  inputProps={{ maxLength: 40 }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  label="Estado"
                  value={formData.tipstatus}
                  onChange={(e) => handleInputChange("tipstatus", e.target.value)}
                  InputLabelProps={{ shrink: true }}
                >
                  <MenuItem value="A">ACTIVO</MenuItem>
                  <MenuItem value="I">INACTIVO</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default EditarTiposCliente
